import React from "react";
import helper from "../helper";

const Component = (props) => {

    const { index, path, name, value, valuetype, maxLength, onBlurError, onInputClicked, onInputChildChanged,
        required, validate, requiredMessage, validationMessage,
        readOnly, currency, placeholder, errors, dataRequired, uppercase, styles,
        inputtype } = props;

    const [dataError, setDataError] = React.useState(false);

    let _errors = errors || [];
    let tInputType = inputtype || "text";

    const OnInputClicked = (e) => {
        e.preventDefault();
        if (onInputClicked) {
            onInputClicked(e.target.name);
        }
    }

    const OnBlurChanged = async (e) => {
        e.preventDefault();

        const name = e.target.name;
        const value = e.target.value;
        setDataError(false);

        if (valuetype && valuetype === "EMAIL") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && !helper.IsEmailValid(value)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "PHONE") {
            let formatVal = helper.ToUSAPhone(value);
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && helper.IsNullValue(formatVal)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                OnTextInputChanged(e, formatVal);
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "NUMBERS") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "SSN") {
            let formatVal = helper.ToSSNNumber(value);
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && helper.IsNullValue(formatVal)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                OnTextInputChanged(e, formatVal);
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "DATE") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && !helper.IsValidateDate(value)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "DOB") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && !helper.IsValidateDate(value, "DOB")) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "ZIP") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value)) {
                global.Busy(true);
                await helper.IsValidZipCode(value)
                    .then((res) => {
                        let tmp = res.data;
                        let data = { state: "", city: "", district: "" };
                        if (tmp.status === 100) {
                            tmp = tmp.data || { state: "", city: "", district: "" };
                            data = { state: tmp.state, city: tmp.city, district: tmp.district };
                        }
                        OnZipUpdated(data);
                    })
                    .catch(() => RaiseOnBlurError(name, validationMessage));
                return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "AADHAR") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && !helper.IsAadharValid(value)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else if (valuetype && valuetype === "PAN") {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else if (validate && !helper.IsNullValue(value) && !helper.IsPanValid(value)) {
                RaiseOnBlurError(name, validationMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        } else {
            if (required && helper.IsNullValue(value)) {
                RaiseOnBlurError(name, requiredMessage); return;
            } else {
                RaiseOnBlurError(name, null, true);
            }
        }
    };

    const RaiseOnBlurError = (name, val, clear, data) => {
        global.Busy(false);
        if (onBlurError) {
            if (!clear) {
                setDataError(true);
            } else {
                setDataError(false);
            }
            onBlurError(name, val, clear, data);
        }
    }

    const OnTextInputChanged = (e, formatVal) => {
        e.preventDefault();
        if (onInputChildChanged) {
            let value = formatVal ? formatVal : e.target.value;
            let _name = GetKeyName();
            if (uppercase && !helper.IsNullValue(value)) value = value.toUpperCase();
            onInputChildChanged(_name, value, index);
        }
    };

    const OnZipUpdated = (value) => {
        global.Busy(false);
        if (onInputChildChanged) {
            let _name = GetKeyName();
            let _path = _name.substring(0, _name.lastIndexOf("_"));
            let obj = {};
            for (var key in value) {
                if (Object.prototype.hasOwnProperty.call(value, key)) {
                    obj[`${_path}_${key}`] = value[key];
                }
            }
            onInputChildChanged(obj, null, index, 'ZIP');
        }
    };

    const GetKeyName = () => {
        let _name = `textinput`;
        if (name) {
            _name = `${name.replace(/\./g, '_')}`;
        } if (path) {
            _name = `${path.replace(/\./g, '_')}`;
        }
        return _name;
    };

    if (helper.IsNullValue(currency)) {
        return (
            <input
                autoComplete={helper.TimeStamp()}
                id={GetKeyName()}
                name={GetKeyName()}
                type={tInputType}
                value={helper.ToString(value)}
                maxLength={maxLength && maxLength}
                placeholder={helper.ToString(placeholder)}
                onChange={(e) => OnTextInputChanged(e)}
                style={{
                    borderColor: helper.GetErrorBackColor(_errors, GetKeyName()),
                    ...styles
                }}
                onKeyPress={(e) => {
                    return valuetype && helper.AcceptedChars(e, valuetype);
                }}
                onBlur={(e) => OnBlurChanged(e)}
                onFocus={(e) => OnInputClicked(e)}
                readOnly={readOnly ? true : undefined}
                data-req={dataRequired}
                data-error={dataError}
                data-req-msg={requiredMessage}
                data-val-msg={validationMessage}
            />
        );
    } else {
        return (
            <div className="input-icon">
                <input
                    autoComplete={"off"}
                    id={GetKeyName()}
                    name={GetKeyName()}
                    type="text"
                    value={helper.ToString(value)}
                    maxLength={maxLength && maxLength}
                    placeholder={helper.ToString(placeholder)}
                    onChange={(e) => OnTextInputChanged(e)}
                    style={{
                        borderColor: helper.GetErrorBackColor(_errors, GetKeyName()),
                        paddingLeft: 20, ...styles
                    }}
                    onKeyPress={(e) => {
                        return valuetype && helper.AcceptedChars(e, valuetype);
                    }}
                    onBlur={(e) => OnBlurChanged(e)}
                    readOnly={readOnly ? true : undefined}
                    data-req={dataRequired}
                    data-req-msg={requiredMessage}
                    data-val-msg={validationMessage}
                />
                <i>{currency}</i>
            </div>
        );
    }
};

export default Component;
